import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ModalWindowParameters} from '../modal-window-parameters';
import {ModalWindowType} from '../modal-window-type';
import {ModalWindowResponse} from '../modal-window-response';

@Component({
  selector: 'app-modal-window',
  templateUrl: './modal-window.component.html',
  styleUrls: ['./modal-window.component.scss']
})
export class ModalWindowComponent implements OnInit {
  public readonly modalWindowType = ModalWindowType;
  @Input() modalWindowParameters: ModalWindowParameters;
  @Output() modalWindowResponse: EventEmitter<ModalWindowResponse> = new EventEmitter<ModalWindowResponse>();

  constructor() { }

  ngOnInit() {
  }
  onResponse(modalWindowResponse: ModalWindowResponse) {
    this.modalWindowResponse.emit(modalWindowResponse);
  }
}
